import ProfileOverview from '../ProfileOverview.vue';

export default {
  path: '/profile',
  name: 'ProfileOverview',
  component: ProfileOverview
};
